import { render, staticRenderFns } from "./workAndEducation.vue?vue&type=template&id=0c24bb9b"
import script from "./workAndEducation.vue?vue&type=script&lang=js"
export * from "./workAndEducation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports